/* ==========================================================================
   Orvo — cut.js
   Loaded only on the ORVO CUT product template. Everything here is scoped
   to [data-kp-root] or a cut section, so it can never fight theme.js.

   Cart writes go through window.OrvoAddToCart (theme.js) so this page reuses
   the same drawer, free-shipping meter and add-to-cart upsell as the rest of
   the store instead of shipping a second cart implementation.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var STR = ((window.Orvo || {}).strings || {});
  var SAVE_FMT = STR.youSaveAtCheckout || STR.youSave || '%s';
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(cents) {
    if (window.OrvoMoney) return window.OrvoMoney(cents);
    var whole = String(Math.floor(Math.abs(cents) / 100)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ');
    var rest = Math.round(Math.abs(cents)) % 100;
    return (cents < 0 ? '-' : '') + whole + (rest ? ',' + (rest < 10 ? '0' : '') + rest : '') + ' kr';
  }
  function headerH() {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0;
  }

  /* ============================================================
     1. GALLERY — slides, thumbs, arrows, swipe
     ============================================================ */
  (function () {
    var gal = qs('[data-kp-gallery]');
    if (!gal) return;
    var slides = qsa('[data-kp-slide]', gal);
    var thumbs = qsa('[data-kp-thumb]', gal);
    var countEl = qs('[data-kp-count]', gal);
    if (!slides.length) return;

    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var moved = false;
    var rail = qs('[data-kp-thumbs]', gal);
    var railWrap = qs('[data-kp-thumbwrap]', gal);

    function edges() {
      if (!rail || !railWrap) return;
      var slack = rail.scrollWidth - rail.clientWidth;
      railWrap.classList.toggle('is-start', rail.scrollLeft <= 1 || slack <= 1);
      railWrap.classList.toggle('is-end', rail.scrollLeft >= slack - 1);
    }
    if (rail) {
      rail.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges, { passive: true });
    }
    function hydrate(slide) {
      var vid = slide && slide.querySelector('video[data-src]');
      if (vid) { vid.setAttribute('src', vid.getAttribute('data-src')); vid.removeAttribute('data-src'); vid.load(); }
      var img = slide && slide.querySelector('img[data-src]');
      if (!img) return;
      var set = img.getAttribute('data-srcset');
      if (set) img.setAttribute('srcset', set);
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
    }
    function show(i) {
      current = (i + slides.length) % slides.length;
      hydrate(slides[current]); hydrate(slides[(current + 1) % slides.length]);
      slides.forEach(function (s, n) {
        var on = n === current;
        s.classList.toggle('is-active', on);
        var v = s.querySelector('video');
        if (v) { if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }
      });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-kp-thumb'), 10) === current); });
      if (countEl) countEl.textContent = (current + 1) + ' / ' + slides.length;
      var active = thumbs[current];
      if (moved && active && rail) {
        var want = active.offsetLeft - (rail.clientWidth - active.offsetWidth) / 2;
        var max = rail.scrollWidth - rail.clientWidth;
        want = Math.max(0, Math.min(want, max));
        if (rail.scrollTo) rail.scrollTo({ left: want, behavior: reduced ? 'auto' : 'smooth' }); else rail.scrollLeft = want;
      }
      moved = true;
      edges();
    }
    gal.addEventListener('click', function (e) {
      if (e.target.closest('[data-kp-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-kp-next]')) { show(current + 1); return; }
      var th = e.target.closest('[data-kp-thumb]');
      if (th) show(parseInt(th.getAttribute('data-kp-thumb'), 10));
    });
    var sx = 0, sy = 0, tracking = false;
    var stage = qs('.kpg__stage', gal);
    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!tracking) return; tracking = false;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) show(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    window.OrvoShowImage = function (imageId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-kp-image-id') !== String(imageId)) continue;
        show(i);
        return true;
      }
      return false;
    };
    show(current);
  })();

  /* ============================================================
     2. BUNDLE TIERS + PER-UNIT OPTION PICKS + ADD TO CART
     ============================================================ */
  (function () {
    var root = qs('[data-kp-root]');
    if (!root) return;
    var product = null;
    try { product = JSON.parse(qs('[data-kp-product-json]', root).textContent); } catch (e) {}
    if (!product || !product.variants) return;

    var colorPos = parseInt(root.getAttribute('data-opt-pos'), 10) || 0;
    var boxes = qsa('[data-kp-tier]', root);
    var totalEl = qs('[data-kp-total]', root);
    var saveEl = qs('[data-kp-save]', root);
    // The sticky bar always shows the entry offer (tier 1); it is rendered by Liquid and never updated here.
    var selected = 2;

    function variantFor(color) {
      var ck = colorPos ? 'option' + colorPos : null;
      if (!ck || color == null) {
        for (var j = 0; j < product.variants.length; j++) { if (product.variants[j].available !== false) return product.variants[j]; }
        return product.variants[0];
      }
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i][ck] === color) return product.variants[i];
      }
      return product.variants[0];
    }
    function currentBox() {
      return boxes.filter(function (b) { return parseInt(b.getAttribute('data-kp-tier'), 10) === selected; })[0];
    }
    function selectTier(n) {
      selected = n;
      boxes.forEach(function (b) {
        var mine = parseInt(b.getAttribute('data-kp-tier'), 10) === n;
        b.classList.toggle('is-selected', mine);
        var head = qs('[data-kp-tier-head]', b);
        if (head) head.setAttribute('aria-pressed', mine ? 'true' : 'false');
      });
      var box = currentBox();
      if (!box) return;
      var total = parseInt(box.getAttribute('data-total'), 10) || 0;
      var save = parseInt(box.getAttribute('data-save'), 10) || 0;
      if (totalEl) totalEl.textContent = money(total);
      if (saveEl) {
        if (save > 0) { saveEl.textContent = SAVE_FMT.replace('%s', money(save)); saveEl.hidden = false; }
        else saveEl.hidden = true;
      }
    }
    // Tier pricing (main-product-bundle): each tier costs the sum of the
    // variants picked in it, less a fixed amount (data-off, whole currency
    // units) when that is above 0, otherwise less the tier's percentage.
    // Sizes can differ in price, so the totals follow the picks.
    var PCT = root.getAttribute('data-pricing') === 'pct';
    var stickyPrice = qs('[data-kp-sticky-price]');
    function recalc() {
      if (!PCT) return;
      boxes.forEach(function (b) {
        var pct = parseFloat(b.getAttribute('data-pct')) || 0;
        var off = parseFloat(b.getAttribute('data-off')) || 0;
        var units = parseInt(b.getAttribute('data-units'), 10) || 1;
        var picks = qsa('[data-kp-pick]', b);
        var sum = 0, was = 0;
        function add(v) { if (!v) return; sum += v.price || 0; was += Math.max(v.compare_at_price || 0, v.price || 0); }
        if (picks.length) picks.forEach(function (p) { add(variantFor(p.getAttribute('data-pick-color'))); });
        else for (var i = 0; i < units; i++) add(variantFor(null));
        var total = off > 0 ? sum - Math.round(off * 100) : Math.round(sum * (100 - pct) / 100);
        b.setAttribute('data-total', total);
        b.setAttribute('data-save', Math.max(0, was - total));
        var tEl = qs('[data-kp-tier-total]', b); if (tEl) tEl.textContent = money(total);
        var wEl = qs('[data-kp-tier-was]', b);
        if (wEl) { wEl.textContent = money(was); wEl.hidden = !(was > total); }
        var sub = qs('[data-kp-sub]', b);
        if (sub && sub.getAttribute('data-tpl')) sub.textContent = sub.getAttribute('data-tpl').replace('[st]', money(Math.round(total / units)));
        var chip = qs('[data-kp-chip]', b);
        if (chip && chip.getAttribute('data-tpl')) chip.textContent = chip.getAttribute('data-tpl').replace('[spar]', money(Math.max(0, sum - total)));
        if (stickyPrice && b.getAttribute('data-kp-tier') === '1') stickyPrice.textContent = money(total);
      });
      selectTier(selected);
    }

    function paintPick(pick, showImage) {
      var color = pick.getAttribute('data-pick-color');
      qsa('[data-kp-swatch]', pick).forEach(function (b) {
        var on = b.getAttribute('data-kp-value') === color;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var v = variantFor(b.getAttribute('data-kp-value'));
        b.classList.toggle('is-oos', !!(v && v.available === false));
      });
      var label = qs('[data-kp-pick-label]', pick);
      if (label) label.textContent = color;
      if (showImage) {
        var variant = variantFor(color);
        if (variant && variant.image_id && window.OrvoShowImage) window.OrvoShowImage(variant.image_id);
      }
    }
    root.addEventListener('click', function (e) {
      var head = e.target.closest('[data-kp-tier-head]');
      if (head) { selectTier(parseInt(head.closest('[data-kp-tier]').getAttribute('data-kp-tier'), 10)); return; }
      var sw = e.target.closest('[data-kp-swatch]');
      if (sw) {
        var pick = sw.closest('[data-kp-pick]');
        if (!pick) return;
        pick.setAttribute('data-pick-color', sw.getAttribute('data-kp-value'));
        paintPick(pick, true);
        recalc();
      }
    });
    root.addEventListener('change', function (e) {
      var sel = e.target.closest ? e.target.closest('[data-kp-select]') : null;
      if (!sel) return;
      var pick = sel.closest('[data-kp-pick]');
      if (!pick) return;
      pick.setAttribute('data-pick-color', sel.value);
      paintPick(pick, true);
      recalc();
    });
    boxes.forEach(function (b) {
      if (b.classList.contains('is-selected')) selected = parseInt(b.getAttribute('data-kp-tier'), 10) || 2;
    });
    selectTier(selected);
    qsa('[data-kp-pick]', root).forEach(function (pick) { paintPick(pick, false); });
    recalc();

    // ---- The sticky bar and every "choose your pack" button land here ----
    document.addEventListener('click', function (e) {
      var jump = e.target.closest('[data-kp-jump]');
      if (!jump) return;
      e.preventDefault();
      var want = parseInt(jump.getAttribute('data-kp-offer-tier'), 10);
      if (want) selectTier(want);
      var picker = qs('[data-kp-picker]');
      if (!picker) return;
      var top = picker.getBoundingClientRect().top + window.pageYOffset - headerH() - 18;
      window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
      picker.classList.remove('is-flash');
      void picker.offsetWidth;
      picker.classList.add('is-flash');
      setTimeout(function () { picker.classList.remove('is-flash'); }, 1400);
    });

    // ---- Add to cart ----
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kp-add]');
      if (!btn) return;
      e.preventDefault();
      var box = currentBox();
      if (!box) return;
      var units = parseInt(box.getAttribute('data-units'), 10) || 1;
      var picks = qsa('[data-kp-pick]', box);
      var items = [];
      if (picks.length) {
        picks.forEach(function (pick) {
          var variant = variantFor(pick.getAttribute('data-pick-color'));
          if (!variant) return;
          var existing = items.filter(function (it) { return it.id === variant.id; })[0];
          if (existing) existing.quantity += 1; else items.push({ id: variant.id, quantity: 1 });
        });
      } else if (product.variants[0]) {
        // Two widths split 50/50 (data-split, set in Liquid): 2 -> 1 + 1, 4 -> 2 + 2, 6 -> 3 + 3.
        if (root.getAttribute('data-split') === 'true' && product.variants.length === 2) {
          var half = Math.floor(units / 2);
          items.push({ id: product.variants[0].id, quantity: units - half });
          if (half) items.push({ id: product.variants[1].id, quantity: half });
        } else {
          items.push({ id: product.variants[0].id, quantity: units });
        }
      }
      if (!items.length) return;
      btn.classList.add('is-shine');
      setTimeout(function () { btn.classList.remove('is-shine'); }, 1200);
      if (window.OrvoAddToCart) window.OrvoAddToCart(items, btn);
      else window.location.href = '/cart';
    });
  })();

  /* ============================================================
     3. STICKY BUY BAR — shows once the picker has scrolled past
     ============================================================ */
  (function () {
    var sticky = qs('[data-kp-sticky]');
    var anchor = qs('[data-kp-picker]');
    if (!sticky || !anchor) return;
    var ticking = false;
    function update() {
      ticking = false;
      var past = anchor.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
    }
    function onScroll() { if (ticking) return; ticking = true; window.requestAnimationFrame(update); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-kp-tier-head]') || e.target.closest('[data-kp-acc]')) setTimeout(update, 420);
    });
    update();
  })();

  /* ============================================================
     4. ACCORDIONS (grid-rows transition, so no fixed heights)
     ============================================================ */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kp-acc]');
    if (!t) return;
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', open ? 'false' : 'true');
    var body = t.nextElementSibling;
    if (!body) return;
    body.classList.toggle('is-open', !open);
    qsa('[data-kp-acc-bar]', body).forEach(function (bar) {
      var b = bar.querySelector('b');
      if (!b) return;
      if (open) { b.style.width = '0%'; return; }
      var pct = bar.getAttribute('data-pct') || 0;
      if (reduced) { b.style.width = pct + '%'; return; }
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { b.style.width = pct + '%'; }); });
    });
  });

  /* ============================================================
     4b. REVIEWS INSIDE THE BUY-BOX ACCORDION (copied from the section)
     ============================================================ */
  (function () {
    var barSlot = qs('[data-kp-acc-bars]');
    var barSrc = qs('.kprev__bars');
    if (barSlot && barSrc) {
      var barsCopy = barSrc.cloneNode(true);
      qsa('[data-kp-bar]', barsCopy).forEach(function (bar) {
        bar.removeAttribute('data-kp-bar'); bar.setAttribute('data-kp-acc-bar', '');
      });
      barSlot.appendChild(barsCopy);
    }
    var slot = qs('[data-kp-acc-reviews]');
    if (!slot) return;
    var source = qsa('[data-kp-review]');
    if (!source.length) return;
    source.slice(0, 3).forEach(function (card) {
      var copy = card.cloneNode(true);
      copy.removeAttribute('data-kp-review'); copy.removeAttribute('id');
      copy.classList.remove('is-extra');
      qsa('[data-kp-review-photo]', copy).forEach(function (img) { img.removeAttribute('data-kp-review-photo'); });
      slot.appendChild(copy);
    });
  })();

  /* ============================================================
     5. SMOOTH SCROLL TO REVIEWS
     ============================================================ */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-kp-scroll-reviews]');
    if (!link) return;
    var target = qs('#omdomen');
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerH();
    window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
  });

  /* ============================================================
     6. REVIEWS — rating bars, filter chips, show more, lightbox
     ============================================================ */
  (function () {
    var sec = qs('[data-kp-reviews]');
    if (!sec) return;
    var bars = qsa('[data-kp-bar]', sec);
    function fillBars() { bars.forEach(function (bar) { var b = bar.querySelector('b'); if (b) b.style.width = (bar.getAttribute('data-pct') || 0) + '%'; }); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { fillBars(); io.disconnect(); } }, { threshold: 0.2 });
      io.observe(sec);
    } else fillBars();

    var list = qs('[data-kp-review-list]', sec);
    var moreBtn = qs('[data-kp-review-more]', sec);
    function revealAll() {
      qsa('.kprv.is-extra', sec).forEach(function (c) { c.classList.remove('is-extra'); });
      if (moreBtn && moreBtn.parentElement) moreBtn.parentElement.hidden = true;
    }
    if (moreBtn) moreBtn.addEventListener('click', revealAll);

    sec.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-kp-filter]');
      if (chip) {
        var want = chip.getAttribute('data-kp-filter');
        qsa('[data-kp-filter]', sec).forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        revealAll();
        qsa('[data-kp-review]', list).forEach(function (card) {
          var stars = card.getAttribute('data-stars');
          var hasPhoto = card.hasAttribute('data-has-photo');
          var show = want === 'all' || (want === 'photo' && hasPhoto) || (want === stars);
          card.classList.toggle('is-filtered-out', !show);
        });
        return;
      }
      var photo = e.target.closest('[data-kp-review-photo]');
      if (photo) openLb(photo.getAttribute('src'));
    });

    var lb = qs('[data-kp-lb]');
    var lbImg = lb ? qs('img', lb) : null;
    function openLb(src) { if (!lb || !lbImg || !src) return; lbImg.src = src; lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeLb() { if (!lb) return; lb.classList.remove('is-open'); document.body.style.overflow = ''; }
    if (lb) {
      lb.addEventListener('click', function (e) { if (e.target.closest('[data-kp-lb-close]') || e.target.classList.contains('kprev__lb-bg')) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb(); });
    }
  })();

  /* ============================================================
     8. AMBIENT VIDEO BANDS (only load when on screen)
     ============================================================ */
  qsa('[data-kp-video-band]').forEach(function (band) {
    var vid = qs('video', band);
    if (!vid || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          if (vid.preload === 'none') { vid.preload = 'auto'; vid.load(); }
          var p = vid.play(); if (p && p.catch) p.catch(function () {});
        } else vid.pause();
      });
    }, { threshold: 0.3 }).observe(band);
  });
})();
